<template>
	<el-container class="friend-page">
		<resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="friend-aside-width">
			<div class="header">
				<el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
					<i class="el-icon-search el-input__icon" slot="prefix"> </i>
				</el-input>
				<el-button plain class="add-btn" icon="el-icon-plus" title="添加好友"
					@click="onShowAddFriend()"></el-button>
				<add-friend :dialogVisible="showAddFriend" @close="onCloseAddFriend"
					@open-requests="onShowFriendRequests"></add-friend>
			</div>
			<div class="friend-request-entry" :class="{ active: activePanel === 'requests' }"
				@click="onShowFriendRequests">
				<div class="request-entry-icon"><i class="el-icon-user-solid"></i></div>
				<div class="request-entry-info">
					<div class="request-entry-title">新的朋友</div>
					<div class="request-entry-desc">好友申请与验证</div>
				</div>
				<div v-if="friendRequestUnreadCount > 0" class="request-entry-badge">
					{{ friendRequestUnreadCount > 99 ? '99+' : friendRequestUnreadCount }}
				</div>
				<i class="el-icon-arrow-right request-entry-arrow"></i>
			</div>
			<el-scrollbar class="friend-items">
				<div v-for="(friends, i) in friendValues" :key="i">
					<div class="letter">{{ friendKeys[i] }}</div>
					<div v-for="(friend) in friends" :key="friend.id">
						<friend-item :friend="friend" :active="friend.id === activeFriend.id"
							@chat="onSendMessage(friend)" @delete="onDelFriend(friend)"
							@click.native="onActiveItem(friend)">
						</friend-item>
					</div>
					<div v-if="i < friendValues.length - 1" class="divider"></div>
				</div>
			</el-scrollbar>
		</resizable-aside>
		<el-container class="container">
			<friend-request ref="friendRequest" v-show="activePanel === 'requests'"
				:active="activePanel === 'requests'" @unread-change="onFriendRequestUnreadChange"></friend-request>
			<div class="friend-detail" v-show="activePanel === 'friends'">
			<div class="header" v-show="userInfo.id">
				{{ userInfo.nickName }}
			</div>
			<div class="empty-state" v-show="!userInfo.id">
				<div class="empty-state-frame">
					<span class="icon iconfont icon-friend"></span>
					<div class="empty-state-title">选择联系人查看资料</div>
					<div class="empty-state-text">好友信息和快捷操作将在这里显示</div>
				</div>
			</div>
			<div v-show="userInfo.id">
				<div class="friend-info">
					<head-image :size="160" :name="userInfo.nickName" :url="userInfo.headImage" radius="10%"
						@click.native="showFullImage()"></head-image>
					<div>
						<div class="info-item">
							<el-descriptions title="好友信息" class="description" :column="1">
								<el-descriptions-item label="用户名">{{ userInfo.userName }}
								</el-descriptions-item>
								<el-descriptions-item label="昵称">{{ userInfo.nickName }}
								</el-descriptions-item>
								<el-descriptions-item label="性别">{{ userInfo.sex == 0 ? "男" : "女"
								}}</el-descriptions-item>
								<el-descriptions-item label="签名">{{ userInfo.signature }}</el-descriptions-item>
							</el-descriptions>
						</div>
						<div class="btn-group">
							<el-button v-show="isFriend" icon="el-icon-position" type="primary"
								@click="onSendMessage(activeFriend)">发消息</el-button>
							<el-button v-show="!isFriend && !isPendingReceived" icon="el-icon-plus" type="primary"
								:disabled="isPendingSent" @click="onAddFriend(userInfo)">{{ isPendingSent ? '等待验证' : '加为好友' }}</el-button>
							<el-button v-show="!isFriend && isPendingReceived" icon="el-icon-user-solid" type="primary"
								@click="onShowFriendRequests">处理好友申请</el-button>
							<el-button v-show="isFriend" icon="el-icon-delete" type="danger"
								@click="onDelFriend(userInfo)">删除好友</el-button>
						</div>
					</div>
				</div>
			</div>
			</div>
		</el-container>
	</el-container>
</template>

<script>
import FriendItem from "../components/friend/FriendItem.vue";
import AddFriend from "../components/friend/AddFriend.vue";
import FriendRequest from "../components/friend/FriendRequest.vue";
import HeadImage from "../components/common/HeadImage.vue";
import ResizableAside from "../components/common/ResizableAside.vue";
import { pinyin } from 'pinyin-pro';

export default {
	name: "friend",
	components: {
		FriendItem,
		AddFriend,
		FriendRequest,
		HeadImage,
		ResizableAside
	},
	data() {
		return {
			searchText: "",
			showAddFriend: false,
			activePanel: "friends",
			friendRequestUnreadCount: 0,
			userInfo: {},
			activeFriend: {}
		}
	},
	methods: {
		onShowAddFriend() {
			this.showAddFriend = true;
		},
		onCloseAddFriend() {
			this.showAddFriend = false;
		},
		onActiveItem(friend) {
			this.activePanel = "friends";
			this.activeFriend = friend;
			this.loadUserInfo(friend.id);
		},
		onShowFriendRequests() {
			this.showAddFriend = false;
			this.activePanel = "requests";
			this.activeFriend = {};
			this.userInfo = {};
		},
		onFriendRequestUnreadChange(count) {
			this.friendRequestUnreadCount = Number(count) || 0;
		},
		onDelFriend(friend) {
			this.$confirm(`确认删除'${friend.nickName}',并清空聊天记录吗?`, '确认解除?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.$http({
					url: `/friend/delete/${friend.id}`,
					method: 'delete'
				})
				this.friendStore.removeFriend(friend.id);
				// 删除会话
				const data = { chatId: friend.id }
				await this.$http({
					url: `/message/private/deleteChat`,
					method: 'delete',
					data: data
				});
				const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friend.id)
				await this.chatStore.remove(convKey);
				this.$message.success("删除好友成功");
			})
		},
		onAddFriend(user) {
			this.$http({
				url: "/friend/request",
				method: "post",
				data: {
					receiverId: user.id,
					verifyMessage: "请求添加你为好友"
				}
			}).then(() => {
				this.$message.success("好友申请已发送，等待对方接受");
				this.$set(user, "relationStatus", "PENDING_SENT");
			})
		},
		async onSendMessage(friend) {
			const convKey = this.$db.buildConversationKey(this.$enums.CONVERSATION_TYPE.PRIVATE, friend.id)
			const chatInfo = {
				key: convKey,
				type: this.$enums.CONVERSATION_TYPE.PRIVATE,
				targetId: friend.id,
				showName: friend.nickName,
				headImage: friend.headImage,
				isDnd: friend.isDnd
			};
			await this.chatStore.openChat(chatInfo);
			await this.chatStore.moveTop(convKey);
			this.chatStore.setActive(convKey);
			this.$router.push("/home/chat");
		},
		showFullImage() {
			if (this.userInfo.headImage) {
				this.$eventBus.$emit("openFullImage", this.userInfo.headImage);
			}
		},
		updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				const friend = JSON.parse(JSON.stringify(this.activeFriend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				this.chatStore.updateFromFriend(friend);
				this.friendStore.updateFriend(friend);
			}
		},
		loadUserInfo(id) {
			// 获取好友用户信息
			this.$http({
				url: `/user/find/${id}`,
				method: 'GET'
			}).then((userInfo) => {
				this.userInfo = userInfo;
				this.updateFriendInfo();
			})
		},
		firstLetter(strText) {
			// 使用pinyin-pro库将中文转换为拼音
			let pinyinOptions = {
				toneType: 'none', // 无声调
				type: 'normal' // 普通拼音
			};
			let pyText = pinyin(strText, pinyinOptions);
			return pyText[0];
		},
		isEnglish(character) {
			return /^[A-Za-z]+$/.test(character);
		}
	},
	computed: {
		isFriend() {
			return this.friendStore.isFriend(this.userInfo.id);
		},
		isPendingSent() {
			return this.userInfo.relationStatus == "PENDING_SENT";
		},
		isPendingReceived() {
			return this.userInfo.relationStatus == "PENDING_RECEIVED";
		},
		friendMap() {
			// 按首字母分组
			let map = new Map();
			this.friendStore.friends.forEach((f) => {
				if (f.deleted || (this.searchText && !f.nickName.includes(this.searchText))) {
					return;
				}
				let letter = this.firstLetter(f.nickName).toUpperCase();
				// 非英文一律为#组
				if (!this.isEnglish(letter)) {
					letter = "#"
				}
				if (f.online) {
					letter = '在线'
				}
				if (map.has(letter)) {
					map.get(letter).push(f);
				} else {
					map.set(letter, [f]);
				}
			})
			// 排序
			let arrayObj = Array.from(map);
			arrayObj.sort((a, b) => {
				// #组在最后面
				if (a[0] == '#' || b[0] == '#') {
					return b[0].localeCompare(a[0])
				}
				return a[0].localeCompare(b[0])
			})
			map = new Map(arrayObj.map(i => [i[0], i[1]]));
			return map;
		},
		friendKeys() {
			return Array.from(this.friendMap.keys());
		},
		friendValues() {
			return Array.from(this.friendMap.values());
		}
	},
	mounted() {
		this.$eventBus.$on("showFriendRequests", this.onShowFriendRequests);
		if (this.$route.query.panel === "requests") {
			this.onShowFriendRequests();
		}
	},
	beforeDestroy() {
		this.$eventBus.$off("showFriendRequests", this.onShowFriendRequests);
	}
}
</script>

<style lang="scss">
.friend-page {
	height: 100%;
	color: var(--im-tech-text);
	background: transparent;

	.header {
		height: 60px;
		flex-shrink: 0;
		display: flex;
		align-items: center;
		padding: 0 12px;
		box-sizing: border-box;
		border-bottom: 1px solid rgba(43, 223, 255, 0.18);
		background:
			linear-gradient(180deg, rgba(10, 42, 82, 0.42), rgba(5, 20, 42, 0.3));

		.search-text {
			flex: 1;

			.el-input__inner {
				height: 38px;
				color: var(--im-tech-text);
				background: rgba(2, 13, 30, 0.46);
				border: 1px solid rgba(43, 223, 255, 0.32);
				border-radius: 8px;
				box-shadow: inset 0 0 18px rgba(0, 112, 255, 0.12);

				&:hover,
				&:focus {
					border-color: rgba(43, 223, 255, 0.78);
					box-shadow: 0 0 0 2px rgba(43, 223, 255, 0.12), inset 0 0 18px rgba(0, 112, 255, 0.16);
				}

				&::placeholder {
					color: rgba(167, 198, 224, 0.64);
				}
			}

			.el-input__prefix {
				color: rgba(43, 223, 255, 0.72);
			}
		}

		.add-btn {
			width: 38px;
			height: 38px;
			padding: 0;
			margin: 5px;
			font-size: 16px;
			border-radius: 50%;
			background:
				linear-gradient(135deg, rgba(8, 125, 255, 0.32), rgba(43, 223, 255, 0.14));
			color: var(--im-tech-cyan);
			transition: all 0.3s ease;
			font-weight: 600;
			border: 1px solid rgba(43, 223, 255, 0.36);
			box-shadow: inset 0 0 12px rgba(43, 223, 255, 0.08);

			&:hover {
				background:
					linear-gradient(135deg, rgba(8, 125, 255, 0.62), rgba(43, 223, 255, 0.34));
				transform: scale(1.05);
				color: #fff;
				border-color: rgba(43, 223, 255, 0.78);
				box-shadow: 0 0 18px rgba(43, 223, 255, 0.3);
			}
		}
	}

	.friend-items {
		flex: 1;
		background:
			linear-gradient(180deg, rgba(6, 25, 50, 0.42), rgba(3, 14, 32, 0.36));

		.letter {
			text-align: left;
			font-size: var(--im-larger-size-larger);
			padding: 5px 15px;
			color: rgba(141, 169, 197, 0.86);
			font-weight: 600;
		}
	}

	.friend-request-entry {
		height: 68px;
		flex-shrink: 0;
		display: flex;
		align-items: center;
		margin: 8px 8px 4px;
		padding: 8px 10px;
		box-sizing: border-box;
		color: var(--im-tech-text);
		background: rgba(5, 27, 54, 0.42);
		border: 1px solid rgba(43, 223, 255, 0.2);
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover,
		&.active {
			background: linear-gradient(135deg, rgba(8, 125, 255, 0.28), rgba(43, 223, 255, 0.1));
			border-color: rgba(43, 223, 255, 0.62);
			box-shadow: 0 0 16px rgba(43, 223, 255, 0.16), inset 0 0 18px rgba(8, 125, 255, 0.1);
		}

		.request-entry-icon {
			width: 42px;
			height: 42px;
			flex-shrink: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #fff;
			font-size: 20px;
			background: linear-gradient(135deg, #087dff, #23dfff);
			border-radius: 8px;
			box-shadow: 0 0 14px rgba(43, 223, 255, 0.24);
		}

		.request-entry-info { flex: 1; min-width: 0; margin-left: 11px; text-align: left; }
		.request-entry-title { color: var(--im-tech-text); font-size: 14px; font-weight: 700; }
		.request-entry-desc { margin-top: 3px; color: var(--im-tech-text-muted); font-size: 11px; }
		.request-entry-badge { min-width: 20px; height: 20px; padding: 0 6px; display: flex; align-items: center; justify-content: center; color: #fff; background: #ff5361; border: 1px solid rgba(255, 255, 255, 0.72); border-radius: 10px; box-sizing: border-box; font-size: 10px; font-weight: 700; box-shadow: 0 0 10px rgba(255, 83, 97, 0.34); }
		.request-entry-arrow { margin-left: 7px; color: rgba(167, 198, 224, 0.58); }
	}
}

.friend-page .container {
	display: flex;
	flex-direction: column;
	min-width: 0;
	color: var(--im-tech-text);
	background: rgba(2, 15, 31, 0.08);

	.friend-detail {
		flex: 1;
		min-height: 0;
		display: flex;
		flex-direction: column;
	}

	.header {
		height: 50px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 12px;
		font-size: var(--im-font-size-larger);
		color: var(--im-tech-text);
		font-weight: 600;
		border-bottom: 1px solid rgba(43, 223, 255, 0.28);
		box-sizing: border-box;
		background:
			linear-gradient(180deg, rgba(10, 42, 82, 0.38), rgba(5, 20, 42, 0.24));
	}

	.empty-state {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		color: var(--im-tech-text-muted);
		background-color: rgba(3, 16, 35, 0.18);
		background-image:
			linear-gradient(rgba(43, 223, 255, 0.06) 1px, transparent 1px),
			linear-gradient(90deg, rgba(43, 223, 255, 0.06) 1px, transparent 1px),
			linear-gradient(180deg, rgba(7, 32, 62, 0.24), rgba(2, 10, 24, 0.3));
		background-size: 42px 42px, 42px 42px, 100% 100%;
	}

	.empty-state-frame {
		min-width: 260px;
		padding: 28px 34px;
		border: 1px solid rgba(43, 223, 255, 0.24);
		border-radius: 8px;
		background: rgba(3, 17, 36, 0.34);
		box-shadow: inset 0 0 22px rgba(43, 223, 255, 0.06);
	}

	.empty-state-frame .icon {
		display: block;
		margin-bottom: 12px;
		color: var(--im-tech-cyan);
		font-size: 34px;
		text-shadow: 0 0 18px rgba(43, 223, 255, 0.5);
	}

	.empty-state-title {
		color: var(--im-tech-text);
		font-size: var(--im-font-size-large);
		font-weight: 600;
		line-height: 28px;
	}

	.empty-state-text {
		margin-top: 4px;
		color: var(--im-tech-text-muted);
		font-size: var(--im-font-size-small);
		line-height: 22px;
	}

	.friend-info {
		display: flex;
		padding: 50px 80px 20px 80px;
		text-align: center;

		.info-item {
			margin-left: 20px;
			background: rgba(3, 17, 36, 0.42);
			border: 1px solid rgba(43, 223, 255, 0.24);
			border-radius: 8px;
			box-shadow: inset 0 0 22px rgba(43, 223, 255, 0.06);
		}

		.description {
			padding: 20px 20px 0 20px;

			.el-descriptions__title {
				color: var(--im-tech-text);
				text-shadow: 0 0 12px rgba(43, 223, 255, 0.22);
			}

			.el-descriptions__body,
			.el-descriptions__table {
				color: var(--im-tech-text);
				background: transparent !important;
			}

			.el-descriptions-row,
			.el-descriptions-item__cell {
				background: transparent !important;
				border-color: rgba(43, 223, 255, 0.14) !important;
			}

			.el-descriptions-item__label,
			.el-descriptions-item__content {
				background: transparent !important;
				color: rgba(232, 247, 255, 0.9) !important;
				font-size: var(--im-font-size);
				line-height: 28px;
			}

			.el-descriptions-item__label {
				color: rgba(141, 169, 197, 0.9) !important;
			}

			.el-descriptions-item__content {
				color: var(--im-tech-text) !important;
			}
		}
	}

	.btn-group {
		text-align: left !important;
		padding: 20px;
	}
}
</style>
